import thunk from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';

import { PROD } from 'config/environments';
import configureStoreProd from 'app/store/configureStoreProd';
import configureStoreDev from 'app/store/configureStoreDev';
import createRootReducer from 'app/reducers';
import analytics from 'app/middlewares/analytics';
import * as api from 'app/api/requests';

const commonMiddlewares = history => [
  routerMiddleware(history),
  thunk.withExtraArgument({ api }),
  analytics,
];

const storeParams = history => ({
  rootReducer: createRootReducer(history),
  middlewares: commonMiddlewares(history),
});

const configureStore = history =>
  process.env.SPA_ENV === PROD
    ? configureStoreProd(storeParams(history))
    : configureStoreDev(storeParams(history));

export default configureStore;
